import classNames from 'classnames';
import React from 'react';

import { LabelHeading } from '@jpp/atoms/Heading';
import useIsMounted from '@jpp/hooks/useIsMounted';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import Termly from 'common/thirdParty/Termly';
import { isClient } from 'common/utils/shared';

import './Policy.scss';

interface IPolicyProps {
  className?: string;
  title: string;
  id: string;
}

const ROOT_CLASSNAME = 'Policy';

const Policy: React.FunctionComponent<IPolicyProps> = ({
  className,
  title,
  id,
}) => {
  const isMounted = useIsMounted();
  const [isVisible, setIsVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const mounted = isMounted.current;

    if (isClient()) {
      setIsVisible(true);
    }

    return () => {
      if (mounted) {
        setIsVisible(false);
      }
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Section className={classNames(ROOT_CLASSNAME, className)}>
      <Container>
        <Row>
          <Flex colLg={10} className="mx-auto">
            <LabelHeading
              className={`${ROOT_CLASSNAME}__heading`}
              heading={title}
            />
            <Termly id={id} />
          </Flex>
        </Row>
      </Container>
    </Section>
  );
};

export default Policy;
